/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Oscari_NInputs */

const en_tut_oscari_n = /** @type {(inputs: Tut_Oscari_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choosing a result does not move your avatar and does not put you into the office — moving stays your decision. Where someone is standing in a room you may not see is simply not shown.`)
};

const id_tut_oscari_n = /** @type {(inputs: Tut_Oscari_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memilih hasil tidak memindahkan avatar Anda dan tidak memasukkan Anda ke kantor — Anda tetap yang memutuskan untuk berpindah. Lokasi rekan di ruang yang tidak boleh Anda lihat memang tidak ditampilkan.`)
};

/**
* | output |
* | --- |
* | "Choosing a result does not move your avatar and does not put you into the office — moving stays your decision. Where someone is standing in a room you may no..." |
*
* @param {Tut_Oscari_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_oscari_n = /** @type {((inputs?: Tut_Oscari_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Oscari_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_oscari_n(inputs)
	return en_tut_oscari_n(inputs)
});